import React from 'react';
import { Box, Typography } from '@material-ui/core';

import useStyles from './styles';

const SectionCard = React.forwardRef((props, ref) => {
  const { children, title, className, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Box
      className={`${classes.container} ${className}`}
      {...otherProps}
      ref={ref}
    >
      {title ? (
        <Typography className="section-title" variant="overline">
          {title}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
});

export default SectionCard;
